export const SITE = {
  brand: "Gihed Coaching",
  coach: "Gihed Kebir",
  whatsappNumber: "+33 6 99 46 02 56",
  whatsappLink: "https://wa.me/33699460256?text=" + encodeURIComponent("Bonjour Gihed, je souhaite réserver ma séance bilan offerte."),
  instagram: "https://www.instagram.com/coach_gi06/",
  linkedin: "https://www.linkedin.com/in/kebir-gihed-848bb7333/",
  email: "contact@gihedcoaching.fr",
  city: "Nice",
  googleReviewsUrl: "https://share.google/xoYOM8deMWdHR47Op",
  sapNumber: "", // NUMÉRO SAP à renseigner avant publication — le bloc crédit d'impôt reste masqué tant que ce champ est vide
  gym: {
    name: "One Fitness Club Villeneuve-Loubet",
    address: "328 route du Bord de Mer, 06270 Villeneuve-Loubet",
    mapsUrl: "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent("One Fitness Club, 328 route du Bord de Mer, 06270 Villeneuve-Loubet"),
    embedUrl: "https://www.google.com/maps?q=" + encodeURIComponent("One Fitness Club, 328 route du Bord de Mer, 06270 Villeneuve-Loubet") + "&output=embed",
  },
};

// Photographies fournies par le coach (optimisées WebP, servies en statique)
export const IMAGES = {
  portrait: "/coach/p5.webp",       // portrait professionnel — hero
  salleClient: "/coach/p4.webp",    // coaching client en salle — One Fitness
  floor: "/coach/p3.webp",          // coaching au sol / bilan — à domicile / qui suis-je
  prepa: "/coach/p2.webp",          // battle ropes — préparation physique
  pullups: "/coach/p1.webp",        // traction assistée — salle dynamique
  prepaSolo: "/coach/prepa_solo.webp",     // Gihed sur le terrain — Nice Futsal Club
  prepaTeam: "/coach/prepa_team.webp",     // équipe Nice Futsal Club
  prepaHuddle: "/coach/prepa_huddle.webp", // brief d'équipe en match
  prepaWalkin: "/coach/prepa_walkin.webp", // entrée équipe avant match
  prepaLadder: "/coach/prepa_ladder.webp", // échelle de vitesse — échauffement
};
